import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'test',
    loadChildren: () => import('./views/homes-list-view/homes-list-view.module').then(m => m.HomesListViewModule),
  },
  {
    path: 'home/:home_id',
    loadChildren: () => import('./views/home-view/home-view.module').then(m => m.HomeViewModule),
  },
  {
    path: 'users/:home_id',
    loadChildren: () => import('./views/users-view/users-view.module').then(m => m.UsersPageModule),
  },
  {
    path: 'modules-settings/:home_id/:module_id',
    loadChildren: () => import('./views/modules-settings-view/modules-settings-view.module').then(m => m.ModuleSettingsViewModule),
  },
  {
    path: 'calibration/:home_id/:module_id',
    loadChildren: () => import('./views/calibration-view/calibration-view.module').then(m => m.CalibrationViewModule),
  },
  {
    path: 'actuator/:home_id/:module_id',
    loadChildren: () => import('./views/actuator-view/actuator-view.module').then(m => m.ActuatorViewModule),
  },
  {
    path: 'notifications/:home_id',
    loadChildren: () => import('./views/notifications-view/notifications-view.module').then(m => m.NotificationsViewModule),
  },
  {
    path: 'automations/:home_id',
    loadChildren: () => import('./views/schedule-automations-view/schedule-automations-view.module').then(m => m.ScheduleAutomationsPageModule),
  },
  {
    path: 'scenario/:home_id',
    loadChildren: () => import('./views/scenarios-view/scenarios-view.module').then(m => m.ScenariosViewModule),
  },
  {
    path: 'first-time-access/:home_id',
    loadChildren: () => import('./views/first-time-schedule-access-view/first-time-schedule-access-view.module').then(m => m.FirstTimeAccessSchedulePageModule),
  },
  {
    path: 'first-time-access/:home_id/room/:room_id',
    loadChildren: () => import('./views/first-time-schedule-access-view/first-time-schedule-access-view.module').then(m => m.FirstTimeAccessSchedulePageModule),
  },
  {
    path: 'tips/sensor-switch-room',
    loadComponent: () => import('./views/tips/sensor-switch/sensor-switch.component').then(m => m.SensorSwitchComponent),
    data: { title: 'app.__SENSOR_SWITCH_PUSH_ROOM_TITLE' },
  },
  {
    path: 'tips/sensor-switch-automations',
    loadComponent: () => import('./views/tips/sensor-switch/sensor-switch.component').then(m => m.SensorSwitchComponent),
    data: { title: 'app.__SENSOR_SWITCH_PUSH_AUTOMATIONS_TITLE' },
  },
  {
    path: 'homecontrol/:home_id',
    redirectTo: '/update-app',
    pathMatch: 'full',
  },
  {
    path: 'update-app',
    loadChildren: () => import('./views/update-app/update-app.module').then(m => m.UpdateAppModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
    }),
  ],
  exports: [
    RouterModule,
  ],
})
export class AppRoutingModule {}
